<template>
    <div>
        <section class="content-header" v-if="header || $slots.header">
            <h1>
                <slot name="header" :text="header">{{ header }}</slot>
                <small><slot name="subheader" :text="subheader">{{ subheader }}</slot></small>
            </h1>
        </section>

        <section class="content">
            <slot></slot>
        </section>
    </div>
</template>

<script>
export default {
    props: ['header', 'subheader'],
}
</script>
